/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import L from "./Lang"
import BaseCom from "./BaseCom";
import DataTable from "./DataTable";
import LoadingAlert from "./LoadingAlert";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { qreq } from "../shared/qrequest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import FormInput from "./FormInput";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import FormLabel from "./FormLabel";
import DocumentList from "./DocumentList"


class DocumentRequests extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loaded: false,
            loading: true,
            showModal: false,
            uploading: false,
            uploadItem: {
                patient: {}
            },
            order: {
                patient: {},
                account: {},
                documents: []
            },
            categories: [],
            accounts: [],
            list: []
        };
        this.load = this.load.bind(this);
        this.upload = this.upload.bind(this);
        this.onSubmitCreate = this.onSubmitCreate.bind(this);
        this.onFileDrop = this.onFileDrop.bind(this);
        this.onFileDragOver = this.onFileDragOver.bind(this);
        this.onFileDragLeave = this.onFileDragLeave.bind(this);
        this.pullOrder = this.pullOrder.bind(this);
    }

    componentDidMount() {
        this.load();
        qreq.get('/api/order/document-category/list', j => {
            if (j.list) {
                j.list.forEach(i => {
                    if (i.name === 'Wound Care Request') {
                        this.state.uploadItem.documentCategoryName = i.name;
                        this.state.uploadItem.documentCategoryID = i.id;
                        this.setState({ uploadItem: this.state.uploadItem });
                    }
                });
                this.setState({ categories: j.list });
            }
            else if (j.errorCode !== 0)
                this.alert(j.errorMessage);
        }, () => {
            this.alert('Unknown error ocurred getting document categories.');
        });
        qreq.get('/api/account/list', j => {
            if (j.list) {
                if (j.list.length === 1)
                    this.state.order.account.id = j.list[0].id;
                this.setState({ accounts: j.list, order: this.state.order });
            }
            else if (j.errorCode !== 0)
                this.alert(j.errorMessage);
        }, () => {
            this.alert('Unknown error ocurred getting account list.');
        });

        document.addEventListener('drop', this.onFileDrop);
        document.addEventListener('dragover', this.onFileDragOver);
        document.addEventListener('dragleave', this.onFileDragLeave);
    }

    componentWillUnmount() {
        document.removeEventListener('drop', this.onFileDrop);
        document.removeEventListener('dragover', this.onFileDragOver);
        document.removeEventListener('dragleave', this.onFileDragLeave);
    }

    load() {
        qreq.get('/api/document/pending/list', j => {
            if (j.errorCode)
                this.alert(j.errorMessage);
            else if (j.list)
                this.setState({ list: j.list });
            this.setState({ loaded: true, loading: false });
        })
    }

    onSubmitCreate(e) {
        e.preventDefault();
        this.state.order.status = 'Document Request';
        qreq.post('/api/order/create', this.state.order, j => {
            if (j.errorCode === 0) {
                this.setState({ showUploadModal: true, showModal: false, order: j.item });
                this.load();
                this.pullOrder(j.item.id);
            }
            else
                this.alert(j.errorMessage);
        });

    }

    upload(e) {
        this.setState({ uploading: true });
        var reader = new FileReader();
        reader.readAsBinaryString(e.target.files[0]);
        reader.onload = () => {
            var b64data = btoa(reader.result);
            qreq.post('/api/order/document/upload', { orderID: this.state.order.id, visitID: 0, fileName: e.target.files[0].name, mimeType: e.target.files[0].type, dataSize: e.target.files[0].size, base64Content: b64data, documentCategoryID: this.state.uploadItem.documentCategoryID }, j => {
                if (j.errorCode === 0) {
                    this.setState({ uploading: false, list: this.state.list });
                    this.pullOrder(this.state.order.id);
                }
                else {
                    this.alert(j.errorMessage);
                    this.setState({ uploading: false });
                }
                e.target.value = '';
            }, () => {
                this.alert('Unknown error ocurred. Please try again.');
                this.setState({ uploading: false });
                e.target.value = '';
            });
        };
        reader.onerror = (error) => {
            console.log('Error: ', error);
            this.setState({ uploading: false });
            e.target.value = '';
        };

    }

    onFileDrop(e) {
        e.preventDefault();


        document.querySelectorAll('.c-dropzone').forEach(i => {
            i.classList.remove('active');
        });

        if (e.dataTransfer && e.dataTransfer.items) {
            [...e.dataTransfer.items].forEach(i => {
                if (i.kind === "file") {
                    const file = i.getAsFile();
                    this.upload({
                        target: {
                            files: [file],
                            value: ''
                        }
                    });
                }
            });
        }
    }

    onFileDragOver(e) {
        e.preventDefault();
        if (this.leaveTimeout)
            clearTimeout(this.leaveTimeout);
        document.querySelectorAll('.c-dropzone').forEach(i => {
            i.classList.add('active');
        });
    }

    onFileDragLeave(e) {
        e.preventDefault();
        if (this.leaveTimeout)
            clearTimeout(this.leaveTimeout);
        this.leaveTimeout = setTimeout(() => {
            document.querySelectorAll('.c-dropzone').forEach(i => {
                i.classList.remove('active');
            });
        }, 500);
    }

    pullOrder(id) {
        qreq.get('/api/order/get/' + id, j => {
            if (j.errorCode === 0)
                this.setState({ order: j.item });
            else
                this.alert(j.errorMessage);
        });
    }

    render() {

        const header = <h1><L>New Patients</L></h1>

        if (!this.state.loaded)
            return <div className="container-fluid">{header}<LoadingAlert /></div>;

        return <div className="container-fluid">
            {header}
            <Modal show={this.state.showModal} onHide={() => this.setState({ showModal: false })}>
                <Modal.Header closeButton>
                    <Modal.Title><L>Create a Document Bucket</L></Modal.Title>
                </Modal.Header>
                <form onSubmit={this.onSubmitCreate}>
                    <Modal.Body>
                        <FormInput model={this.state.order.account} name="id" label="Account" type="select" options={this.state.accounts} />
                        <div className="row">
                            <div className="col">
                                <FormInput model={this.state.order.patient} name="firstName" label="Patient First Name" type="text" required />
                            </div>
                            <div className="col">
                                <FormInput model={this.state.order.patient} name="lastName" label="Patient Last Name" type="text" required />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ showModal: false })} disabled={this.state.uploading}>
                            Close
                        </Button>
                        <button type="submit" className="btn btn-primary" disabled={this.state.uploading}>
                            <FontAwesomeIcon icon={fa.faSave} /><L>Create Document Bucket</L></button>
                    </Modal.Footer>
                </form>
            </Modal>
            <Modal show={this.state.showUploadModal} onHide={() => this.setState({ showUploadModal: false })}>
                <Modal.Header closeButton>
                    <Modal.Title><L>Upload a Document</L></Modal.Title>
                </Modal.Header>
                <form onSubmit={(e) => { e.preventDefault(); if (this.state.uploadItem.documentCategoryID) document.getElementById('c-documentrequests-upload').click(); else this.alert('Please select a Document Type.'); }}>
                    <Modal.Body>
                        <FormLabel model={this.state.order.patient.name} name="patientName" label="Patient Name" />
                        <DocumentList model={this.state.order} list={this.state.order.documents} edit showUploadButton={false} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ showUploadModal: false })} disabled={this.state.uploading}>
                            Close
                        </Button>
                        <button type="submit" className="btn btn-primary" disabled={this.state.uploading}>
                            <FontAwesomeIcon icon={fa.faUpload} /><L>Select File</L></button>
                    </Modal.Footer>
                </form>
            </Modal>
            <div className="d-none"><input type="file" id="c-documentrequests-upload" onChange={this.upload} /></div>
            <div className="btn-group p-3">
                <button type="button" className="btn btn-primary" onClick={() => this.setState({ order: { patient: {}, account: {}, documents: [] }, showModal: true })}><FontAwesomeIcon icon={fa.faUpload} /><L>Create New Patient</L></button>
            </div>
            <DataTable data={this.state.list} columns={[
                { icon: 'Upload', onClick: (row) => { this.setState({ order: row }); this.setState({ showUploadModal: true }); }, tooltip: 'Upload Documents' },
                { name: 'patientName', title: 'Patient Name', onClick: (row) => { this.pullOrder(row.id); this.setState({ showUploadModal: true }); }, tooltip: 'Upload Documents' },
                { name: 'status', title: 'Status' },
                { name: 'createdByUserName', title: 'Created By' },
                { name: 'createdDate', title: 'Uploaded On', format: 'datetime' }
            ]} loading={this.state.loading} />
        </div>;
    }
}

export default withParamsAndNavigate(DocumentRequests);